import { useState, useEffect } from "react"
import "./Faqs.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const Faqs = () => {
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);
    useEffect(() => {
        window.scrollTo(0, 0);   // scroll to top
        AOS.init({ duration: 1000 });
    }, []);
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const faqs = [
        {
            question: "How does the “80% AI / 100% attorney” actually work?",
            badge: "core model",
            answer:
                "Our O'Hanlon-patented AI handles the structured foundation: it generates invention summaries, organizes technical flows, and suggests early claim language based on millions of prior art documents..."
        },
        {
            question: "Is my invention kept confidential?",
            badge: "privacy",
            answer:
                "Absolutely. Your drafts and disclosures are encrypted, access-controlled, and never used to train public models..."
        },
        {
            question: "Do I get a patent attorney for every filing?",
            badge: "legal review",
            answer:
                "When you select the attorney review option, a registered patent attorney from our O'Hanlon network is assigned."
        },
        {
            question: "What patents can I draft? provisional, utility, design?",
            badge: "scope",
            answer:
                "Our AI supports utility (provisional and non‑provisional), design, and plant patent applications. The O'Hanlon framework is particularly strong for utility patents with complex technical specs. We also provide trademark and prior art search integration."
        },
        {
            question: "How much does it cost?",
            badge: "pricing",
            answer:
                "AI‑only plans start at $49/month (billed annually) for solo inventors. Professional plans with attorney review begin at $1,500 per filing + government fees. We also offer flat‑rate prior art searches ($295) and invalidity searches (from $2,500). All fees are transparent – no hidden costs."
        },
        {
            question: "What is the O'Hanlon patent framework?",
            badge: "methodology",
            answer:
                "It's a proprietary set of algorithms and legal logic developed by former USPTO examiners and AI engineers. It organizes claim language, maps prior art, and structures technical descriptions to meet stringent patent office requirements. The framework is protected by issued and pending patents."
        },
        {
            question: "Can I file internationally?",
            badge: "global",
            answer:
                "Yes. Our system supports PCT national phase entries, European Patent Office validations, and other major jurisdictions. O'Hanlon‑affiliated attorneys coordinate with local counsel to ensure compliance."
        },
        {
            question: "What if my application gets rejected?",
            badge: "support",
            answer:
                "If you used attorney review, they will help draft responses to office actions (additional fees may apply). For AI‑only users, we offer on‑demand attorney consultations. Our goal is to get you granted, not just filed."
        },
        {
            question: "Is there a free trial?",
            badge: "getting started",
            answer:
                "We offer a 7‑day free trial for the AI‑drafting environment (limited to one invention). You can test the interface, see how the O'Hanlon AI structures claims, and then decide to subscribe or purchase a search."
        }
    ];
    return (
        <>
            <Header />
            {/* <!-- no header, just hero with floating badge --> */}
            <section className="faq-hero">
                <div className="hero-background"></div>
                <div className="floating-element"></div>
                <div className="floating-element"></div>
                <div className="content-container">
                    <div className="hero-content">
                        <div className="identifier-mini" data-aos="fade-down">
                            <i className="fa-regular fa-circle-question"></i> FREQUENTLY ASKED QUESTIONS · ASK JEEVES IP
                        </div>
                        <h1 className="hero-title" data-aos="fade-up">Questions about the<br />O'Hanlon standard?</h1>
                        <p className="hero-subtitle" data-aos="fade-up" data-aos-delay="100">Answers from our patent attorneys & AI architects.</p>
                    </div>
                </div>
            </section>
            {/* <!-- main faq card --> */}
            <div className="content-container">
                <div className="faq-card" data-aos="fade-up">

                    <div className="faq-grid">

                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                                onClick={() => toggleFAQ(index)}
                            >

                                <div className="faq-question">
                                    <i
                                        className={`fa-regular ${activeIndex === index
                                            ? "fa-circle-minus"
                                            : "fa-circle-plus"
                                            }`}
                                    ></i>

                                    <h3>
                                        {faq.question}{" "}
                                        <span className="badge-cat">{faq.badge}</span>
                                    </h3>
                                </div>

                                {activeIndex === index && (
                                    <div className="faq-answer">
                                        <p>{faq.answer}</p>
                                    </div>
                                )}
                            </div>
                        ))}

                    </div>

                    {/* Contact box */}

                    <div className="contact-box" data-aos="fade-up">
                        <i className="fa-regular fa-message"></i>

                        <div style={{ flex: 1 }}>
                            <h3 style={{ color: "#0B1E4A", marginBottom: "0.5rem" }}>
                                Still have questions?
                            </h3>

                            <p style={{ marginBottom: 0 }}>
                                Chat with our team or email{" "}
                                <strong>faq@askjeevesip.tech</strong> – we usually reply within
                                4 hours (business days).
                            </p>
                        </div>

                        <Link to={"/contact"}
                            className="btn btn-primary"
                        >
                            Contact us
                        </Link>
                    </div>

                    <hr
                        style={{
                            margin: "3rem 0",
                            border: "1px solid #e5ecf5"
                        }}
                    />

                    <div
                        style={{
                            textAlign: "center",
                            color: "#1D3A90"
                        }}
                    >
                        <i className="fa-regular fa-circle-check"></i> More questions? Visit
                        our help center.
                    </div>

                </div>
            </div>
            <Footer />
        </>
    )
}

export default Faqs;